import Factoid from './Factoid';
export default Factoid;